import { navigate } from "gatsby";
import moment from "moment";
import { handleResponse } from "../types/record";

export const getLocalStorage = (item: string) => {
  return isBrowser() && windowGlobal.localStorage.getItem(item)
    ? JSON.parse(windowGlobal.localStorage.getItem(item))
    : "";
};

const BASE_URL = "https://metis.iwasaki.ac.jp/isc/rel/healthcheckapi.php?type";

export const isBrowser = () => typeof window !== "undefined";
const windowGlobal = typeof window !== "undefined" && window;

interface handleProps {
  result: string;
  records?: Array<{
    date: "string";
  }>;
  reason?: string;
  email?: string;
  name?: string;
  dates?: Array<string>;
}

/******************************
 * handler
 ******************************/

export const handleLogin = async (
  values: { id: string; password: string },
  setErrors: Function,
  successCallback: Function,
  errorCallback: Function,
  signal?
) => {
  const { id, password } = values;
  const res = await fetch(`${BASE_URL}=login`, {
    method: "POST",
    mode: "cors",
    body: JSON.stringify({ id, password }),
    signal,
  });

  const data = await res.json();
  if (data.result === "success") {
    windowGlobal.localStorage.setItem("userId", JSON.stringify(id));
    windowGlobal.localStorage.setItem("userToken", JSON.stringify(data.token));
    successCallback();
  } else {
    errorCallback();
  }
};

export const handleSetRecord = async (
  body: any,
  callback: Function,
  signal?
) => {
  const id = await getLocalStorage("userId");
  const token = await getLocalStorage("userToken");

  const req = {
    body,
    id,
    token,
  };
  const res = await fetch(`${BASE_URL}=regist`, {
    method: "POST",
    mode: "cors",
    body: JSON.stringify({ ...body, id, token }),
    signal,
  });

  const data: handleProps = await res.json();
  if (data.result === "success") {
    callback();
  } else {
    // FAILED POST DATE CASE
  }
};

export const handleSetEmail = async (email, callback, signal?) => {
  const id = await getLocalStorage("userId");
  const token = await getLocalStorage("userToken");

  const res = await fetch(`${BASE_URL}=email`, {
    method: "POST",
    mode: "cors",
    body: JSON.stringify({ token, id, email }),
  });
  const data: handleProps = await res.json();
  if (data.result === "success") {
    await callback();
    return;
  } else {
  }
};

export const handleSetPassword = async (
  oldpass,
  newpass,
  successCallback,
  errorCallback,
  signal?
) => {
  const id = await getLocalStorage("userId");
  const token = await getLocalStorage("userToken");

  const res = await fetch(`${BASE_URL}=password`, {
    method: "POST",
    mode: "cors",
    body: JSON.stringify({ id, token, oldpass, newpass }),
  });
  const data: handleProps = await res.json();
  if (data.result === "success") {
    await successCallback();
    return;
  } else {
    await errorCallback();
  }
};

export const handleLogout = async () => {
  const id = await getLocalStorage("userId");
  const token = await getLocalStorage("userToken");

  const res = await fetch(`${BASE_URL}=logout`, {
    method: "POST",
    mode: "cors",
    body: JSON.stringify({ token, id }),
  });

  const data: handleProps = await res.json();
  if (data.result === "success") {
    localStorage.removeItem("userToken");
    navigate("/");
    return;
  }
};

export const handleGetUser = async (signal?) => {
  const id = await getLocalStorage("userId");
  const token = await getLocalStorage("userToken");

  const res = await fetch(`${BASE_URL}=user`, {
    method: "POST",
    mode: "cors",
    body: JSON.stringify({ token, id }),
    signal,
  });

  const data: handleProps = await res.json();
  return data;
};

export const handleGetRecordOfDay = async (callback, signal) => {
  const id = await getLocalStorage("userId");
  const token = await getLocalStorage("userToken");
  const now = moment().format("YYYYMMDD");

  const obj = {
    start: now,
    end: now,
  };

  const res = await fetch(`${BASE_URL}=list`, {
    method: "POST",
    mode: "cors",
    body: JSON.stringify({ token, id, ...obj }),
    signal,
  });

  const data: handleResponse = await res.json();
  if (data.result === "success") {
    callback(data);
  }
};

export const handleGetHistory = async (callback, signal?) => {
  const BASE = moment("20200401");
  const START = moment("20200401");
  const END = moment();
  const DIFF_MONTH = END.diff(START, "month");

  const obj = {
    start: START.format("YYYYMMDD"),
    end: END.format("YYYYMMDD"),
  };

  const history = {};

  for (let i = 0; i <= DIFF_MONTH; i++) {
    history["H" + BASE.format("YYYYMM")] = [];
    BASE.add(1, "month");
  }

  const id = await getLocalStorage("userId");
  const token = await getLocalStorage("userToken");

  const res = await fetch(`${BASE_URL}=list`, {
    method: "POST",
    mode: "cors",
    body: JSON.stringify({ id, token, ...obj }),
    signal,
  });

  const data: handleProps = await res.json();
  if (data.result === "success") {
    const WE = moment("20200401").endOf("week");

    Object.keys(history).map((item) => {
      const m = item.substring(1);
      const ME = moment(`${m}01`)
        .endOf("month")
        .format("YYYYMMDD");

      while (true) {
        const week = data.records.filter(
          (item) => item.date <= WE.format("YYYYMMDD") && item.date <= ME
        );
        if (week.length === 0) {
          break;
        } else if (WE.format("YYYYMMDD") > ME) {
          history[item].push(week);
          data.records.splice(0, week.length);
        } else {
          history[item].push(week);
          data.records.splice(0, week.length);
          WE.add(1, "week");
        }
      }
    });

    callback(history);
  }
};

export const handleGetUnfinishedList = async (callback: Function, signal?) => {
  const id = await getLocalStorage("userId");
  const token = await getLocalStorage("userToken");

  const res = await fetch(`${BASE_URL}=check`, {
    method: "POST",
    mode: "cors",
    body: JSON.stringify({ token, id }),
    signal,
  });

  const data: handleProps = await res.json();
  if (data.result === "success") {
    await callback(data.dates);
  }
};
